/** Compact display for hero sidebar (Figma aside). */

export const formatHumanEffortDisplay = (raw: string): string => {
  const hours = raw.match(/(\d+)\s*hours?\b/i)
  if (hours) {
    return `${hours[1]}h`
  }
  const hOnly = raw.match(/^(\d+)\s*h\b/i)
  if (hOnly) {
    return `${hOnly[1]}h`
  }
  return raw.trim()
}

export const formatAccelerationDisplay = (raw: string): string => {
  const xPrefix = raw.match(/\b(\d+)\s*x\b/i)
  if (xPrefix) {
    return `x${xPrefix[1]}`
  }
  const xWord = raw.match(/\bx\s*(\d+)\b/i)
  if (xWord) {
    return `x${xWord[1]}`
  }
  return raw.trim()
}

/**
 * Maps free-text hero fields to a 1–5 score for the vertical bar meter.
 * Returns null when no heuristic matches (caller should render plain text).
 */
export const parseLikert5FromText = (raw: string | undefined): number | null => {
  if (!raw?.trim()) {
    return null
  }
  const explicit = raw.match(/(\d)\s*\/\s*5\b/)
  if (explicit) {
    const n = Number(explicit[1])
    return Number.isFinite(n) ? Math.max(1, Math.min(5, n)) : null
  }

  const t = raw.toLowerCase()
  if (/\bvery\s+high\b|\bmaximum\b|\ball\s*time\b/.test(t)) {
    return 5
  }
  if (/\bhigh\b/.test(t) && /human\s+review|with\s+human/.test(t)) {
    return 4
  }
  if (/\bhigh\b/.test(t)) {
    return 5
  }
  if (/\bmedium\b|\bmoderate\b/.test(t)) {
    return 3
  }
  if (/\blow\b/.test(t)) {
    return 2
  }
  return null
}
